import { useLocation, useNavigate } from "react-router-dom";
import { STATUS_TRANSACTION } from "../../../constants/constant";

const TabNavigationTransaction = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex items-end mb-4 overflow-x-auto">
      <div className="flex text-center w-full">
        {STATUS_TRANSACTION.map((status) => (
          <p
            onClick={() =>
              navigate(`/purchase-pbf/list-transaction/${status.status_id}`)
            }
            className={`w-full py-2 px-8 border-b-2 hover:text-gray-300 cursor-pointer whitespace-nowrap ${
              pathname === `/purchase-pbf/list-transaction/${status.status_id}`
                ? "border-blue-500 text-blue-500"
                : ""
            }`}
          >
            {status.status_name}
          </p>
        ))}
      </div>
      <hr className="w-full text-gray-400 border-t-2" />
    </div>
  );
};

export default TabNavigationTransaction;
